<template>
  <div
    :class="{
      'is-wide container mt-16 md:mt-32 lg:mt-56':
        !parentType || parentType === 'container',
      'mobile-only:!p-0': options.scrollableOnMobile,
    }"
  >
    <div
      class="paragraph-grid"
      :class="{ 'is-scrollable': options.scrollableOnMobile }"
    >
      <BlokkliField
        :list="paragraphs"
        name="field_paragraphs"
        class="teaser-grid c"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphContainerFragment } from '#graphql-operations'
// hyphen is CommonJS; use default import so it works in Node ESM (SSR)
import pkgDe from 'hyphen/de'
import pkgEn from 'hyphen/en'
import pkgFr from 'hyphen/fr'
import pkgIt from 'hyphen/it'
const hyphenateDe = pkgDe.hyphenateSync
const hyphenateEn = pkgEn.hyphenateSync
const hyphenateFr = pkgFr.hyphenateSync
const hyphenateIt = pkgIt.hyphenateSync

defineProps<{ paragraphs?: ParagraphContainerFragment['paragraphs'] }>()

const language = useCurrentLanguage()

const hyphenators: Record<string, (text: string) => string> = {
  de: hyphenateDe,
  en: hyphenateEn,
  fr: hyphenateFr,
  it: hyphenateIt,
}

// Provide hyphenation for teaser title/body in this grid (soft hyphens \u00AD), per current language
provide<(text: string) => string>('hyphenateTeaserTitle', (text: string) => {
  const langCode = language.value.split('-')[0] ?? 'en'
  const hyphenate = hyphenators[langCode] ?? hyphenators.en
  return hyphenate ? hyphenate(text) : text
})

const { parentType, options } = defineBlokkli({
  bundle: 'grid',
  editor: {
    addBehaviour: 'no-form',
  },
  options: {
    scrollableOnMobile: {
      type: 'checkbox',
      label: 'Scrollbar auf Mobile',
      default: false,
    },
  },
  propsFieldMapping: {
    paragraphs: { type: 'field', name: 'field_paragraphs' },
  },
})

defineOptions({
  name: 'ParagraphGrid',
})
</script>

<style lang="postcss">
.paragraph-grid {
  &.is-scrollable {
    @apply mobile-only:overflow-hidden;
    .teaser-grid {
      @apply mobile-only:flex mobile-only:overflow-auto mobile-only:pb-20;
      @apply mobile-only:snap-x mobile-only:snap-proximity;

      > div {
        @apply mobile-only:w-[270px] mobile-only:flex-none mobile-only:snap-center mobile-only:first:pl-16 mobile-only:last:pr-16;
      }
    }
  }
}
</style>
